module.exports = __webpack_public_path__ + "static/img/157_TO8_1881_og.0f39c03.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/157_TO8_1881_og.jpg
// module id = ENpX
// module chunks = 0